import { Box, CircularProgress } from '@mui/material';

// Create a loading component for Suspense fallback
const LoadingComponent = ({ size = 'medium' }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      py: 2,
    }}
  >
    <CircularProgress 
      color="primary" 
      size={size === 'small' ? 24 : size === 'large' ? 48 : 40}
    />
  </Box>
);

export default LoadingComponent;